import { Customer } from "./customer";
import { CustomerContactCard } from "./customer-contact-card";
import { CustomerContactDiscount } from "./customer-contact-discount";

export class CustomerContact {
    id!: number
    created_at!: Date
    updated_at!: Date
    created_by_id!: number
    updated_by_id!: number
    first_name!: string
    last_name!: string
    title!: string
    email!: string
    mobile_phone!: string
    notes!: string
    shift_confirmations!: boolean
    disable_login!: boolean
    cards!: CustomerContactCard[]
    default_card_id!: number
    balance!: number
    show_reports!: boolean
    referral_code!: string
    first_order_at!: Date
    referral_discount_id!: number
    default_customer_id!: number
    default_customer = new Customer()
    picture!: string
    discounts: CustomerContactDiscount[] = []
}
